"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./Accordion.css");
var icons = require("../../../styles/att-icons.css");
var ContainerLoader_1 = require("../../atoms/ContainerLoader/ContainerLoader");
var Animate_1 = require("../Animate/Animate");
var Label_1 = require("../../atoms/Label");
var LabelProps_1 = require("../../atoms/Label/LabelProps");
var Accordion = /** @class */ (function (_super) {
    __extends(Accordion, _super);
    function Accordion(props) {
        var _this = _super.call(this, props) || this;
        _this.onClick = _this.onClick.bind(_this);
        _this.setAccordionState = _this.setAccordionState.bind(_this);
        _this.state = {
            isOpen: (_this.props.data.setOpen !== undefined && _this.props.data.setOpen !== null) ?
                _this.props.data.setOpen : false,
            isSelectionComplete: (_this.props.data.setSelectionCompleted !== undefined &&
                _this.props.data.setSelectionCompleted !== null) ?
                _this.props.data.setSelectionCompleted : false,
            showError: false,
        };
        _this.bindAll();
        return _this;
    }
    Accordion.prototype.bindAll = function () {
        this.getSubTitleClasses = this.getSubTitleClasses.bind(this);
        this.getExternalContainerClasses = this.getExternalContainerClasses.bind(this);
        this.getaccordionContentClasses = this.getaccordionContentClasses.bind(this);
        this.getTitleClasses = this.getTitleClasses.bind(this);
        this.showAccordionDisplay = this.showAccordionDisplay.bind(this);
        this.showTail = this.showTail.bind(this);
        this.showSubTitle = this.showSubTitle.bind(this);
        this.showMessage = this.showMessage.bind(this);
        this.showAccordionPanel = this.showAccordionPanel.bind(this);
        this.showAccordionContent = this.showAccordionContent.bind(this);
    };
    Accordion.prototype.componentDidUpdate = function (prevProps) {
        if ((this.props.data) &&
            (this.props.data.setOpen !== undefined && this.props.data.setOpen !== null) &&
            (prevProps !== this.props)) {
            this.setState({ isOpen: this.props.data.setOpen });
        }
    };
    Accordion.prototype.getAccordionContent = function () {
        if (this.props.options && this.props.options.isLoading) {
            return (React.createElement(ContainerLoader_1.default, null));
        }
        else {
            return (this.props.children);
        }
    };
    Accordion.prototype.getExternalContainerClasses = function () {
        if (this.props.options && this.props.options.className && this.props.options.className.externalContainerClasses) {
            return this.props.options.className.externalContainerClasses;
        }
        else {
            return '';
        }
    };
    Accordion.prototype.getaccordionContentClasses = function () {
        if (this.props.options && this.props.options.className && this.props.options.className.accordionContentClasses) {
            return this.props.options.className.accordionContentClasses;
        }
        else {
            return '';
        }
    };
    Accordion.prototype.getTitleClasses = function () {
        if (this.props.options && this.props.options.className && this.props.options.className.titleClasses) {
            return this.props.options.className.titleClasses;
        }
        else {
            return '';
        }
    };
    Accordion.prototype.getSubTitleClasses = function () {
        if (this.props.options && this.props.options.className && this.props.options.className.subTitleClasses) {
            return this.props.options.className.subTitleClasses;
        }
        else {
            return '';
        }
    };
    Accordion.prototype.getAccordionContentClasses = function () {
        if (this.props.options && this.props.options.className && this.props.options.className.accordionContentClasses) {
            return this.props.options.className.accordionContentClasses;
        }
        else {
            return '';
        }
    };
    Accordion.prototype.showAccordionDisplay = function () {
        var accessibilityText = this.props.data.titleAriaLabel ? this.props.data.titleAriaLabel : this.props.data.title;
        return (React.createElement("button", { type: "button", "aria-label": this.state.isOpen ? 'Hide ' + accessibilityText : 'Show ' + accessibilityText, "aria-expanded": this.state.isOpen, className: styles.opener, style: { backgroundColor: this.showTailExists ? this.getAccordionPanelColor() : 'transparent' }, onClick: this.onClick },
            React.createElement("span", { className: [styles.accordionTitle, this.getTitleClasses()].join(' '), style: this.updateZIndex() }, this.props.data.title),
            React.createElement("i", { className: [icons.attIcon,
                    icons.attIconDown, styles.iconFix, (this.state.isOpen ? styles.opened : '')].join(' ') })));
    };
    Accordion.prototype.getAccordionPanelColor = function () {
        if (this.showTailExists && this.panelColorExists) {
            return this.props.options.panelColor;
        }
        else if (this.showTailExists && !this.panelColorExists) {
            return 'white';
        }
        else {
            return 'transparent';
        }
    };
    Accordion.prototype.showTail = function () {
        var tailStyles = {
            backgroundColor: this.panelColorExists ? this.props.options.panelColor : 'white',
            height: this.tailSizeExists ? this.props.options.tailStyles.size + 'px' : '20px',
            marginBottom: this.bottomTailMarginExists ? this.props.options.tailStyles.bottomMargin + 'px' : '10px',
            marginLeft: this.leftTailMarginExists ? this.props.options.tailStyles.leftMargin + 'px' : '25px',
            marginTop: this.getTailTopMargin(),
            transform: 'rotate(45deg)',
            width: this.tailSizeExists ? this.props.options.tailStyles.size + 'px' : '20px',
            zIndex: 0,
        };
        return (this.props.options && this.props.options.showTail &&
            React.createElement("div", { style: tailStyles }));
    };
    Object.defineProperty(Accordion.prototype, "topTailMarginExists", {
        get: function () {
            return (this.props.options &&
                this.props.options.tailStyles &&
                this.props.options.tailStyles.topMargin);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Accordion.prototype, "tailSizeExists", {
        get: function () {
            return (this.props.options &&
                this.props.options.tailStyles &&
                this.props.options.tailStyles.size);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Accordion.prototype, "bottomTailMarginExists", {
        get: function () {
            return this.props.options &&
                this.props.options.tailStyles &&
                this.props.options.tailStyles.bottomMargin;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Accordion.prototype, "leftTailMarginExists", {
        get: function () {
            return this.props.options &&
                this.props.options.tailStyles &&
                this.props.options.tailStyles.leftMargin;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Accordion.prototype, "panelColorExists", {
        get: function () {
            return this.props.options &&
                this.props.options.panelColor;
        },
        enumerable: false,
        configurable: true
    });
    Accordion.prototype.getTailTopMargin = function () {
        var defaultTailSize = 10;
        var initialTopMargin = this.tailSizeExists ? this.props.options.tailStyles.size / 2 : defaultTailSize;
        var customTopMargin = this.topTailMarginExists ? this.props.options.tailStyles.topMargin : 0;
        var adjustedTopMargin = -(initialTopMargin) + customTopMargin;
        return adjustedTopMargin;
    };
    Accordion.prototype.showTailExists = function () {
        return this.props.options && this.props.options.showTail;
    };
    Accordion.prototype.showSubTitle = function () {
        var subtitle2 = Array.isArray(this.props.data.subTitle2) ?
            this.props.data.subTitle2.join(', ') : this.props.data.subTitle2;
        return (React.createElement(Animate_1.default, { options: {
                affectChildNodes: false,
                collapseAnimSettings: {
                    fadeIn: { duration: 400 },
                    scale: { duration: 200 },
                },
                collapseAnimType: 'COLLAPSE_PANEL',
                expandAnimSettings: {
                    fadeOut: { duration: 400 },
                    scale: { duration: 200 },
                },
                expandAnimType: 'EXPAND_PANEL',
                isVisible: (!this.state.isOpen && this.state.isSelectionComplete),
                maintainStructure: false,
                playAnimOnCollapse: true,
                playAnimOnExpand: true,
            } },
            React.createElement("div", { className: styles.accordionSubtitle },
                React.createElement("span", { className: styles.accordionSubtitleIcon }, "|"),
                Array.isArray(this.props.data.subTitle) ?
                    this.props.data.subTitle.join(', ') : this.props.data.subTitle,
                React.createElement("div", null, this.props.data.subTitle2 ?
                    React.createElement(Label_1.default, { data: { text: subtitle2 }, options: { className: styles.accordionSubtitle2, size: LabelProps_1.LabelSizes.SMALL } }) : ''))));
    };
    Accordion.prototype.showMessage = function () {
        return (React.createElement(Animate_1.default, { options: {
                affectChildNodes: false,
                collapseAnimSettings: {
                    fadeIn: { duration: 400 },
                    scale: { duration: 200 },
                },
                collapseAnimType: 'COLLAPSE_PANEL',
                expandAnimSettings: {
                    fadeOut: { duration: 400 },
                    scale: { duration: 200 },
                },
                expandAnimType: 'EXPAND_PANEL',
                isVisible: ((this.props.data.requiresSelection
                    && !this.state.isOpen && !this.state.isSelectionComplete) ||
                    this.state.showError),
                maintainStructure: false,
                playAnimOnCollapse: true,
                playAnimOnExpand: true,
            } },
            React.createElement("div", { className: [styles.accordionSubtitle, this.getSubTitleClasses()].join(' ') },
                React.createElement("i", { className: [icons.attIcon, icons.attIconBadgealert, styles.accordionMessageIcon].join(' ') }),
                this.props.data.message)));
    };
    Accordion.prototype.showAccordionPanel = function () {
        return (React.createElement("div", { className: styles.accordionPanel, style: { backgroundColor: this.getAccordionPanelColor() } },
            this.showAccordionDisplay(),
            this.showSubTitle(),
            this.showMessage()));
    };
    Accordion.prototype.showAccordionContent = function () {
        return (React.createElement(Animate_1.default, { options: {
                affectChildNodes: true,
                collapseAnimSettings: {
                    fadeIn: { duration: 800 },
                    scale: { duration: 400 },
                },
                collapseAnimType: 'COLLAPSE_PANEL',
                expandAnimSettings: {
                    fadeOut: { duration: 800 },
                    scale: { duration: 400 },
                },
                expandAnimType: 'EXPAND_PANEL',
                isVisible: this.state.isOpen,
                maintainStructure: false,
                playAnimOnCollapse: true,
                playAnimOnExpand: true,
            } },
            React.createElement("div", { className: [styles.accordionContent, this.getAccordionContentClasses()].join(' ') }, this.getAccordionContent())));
    };
    Accordion.prototype.updateZIndex = function () {
        return {
            backgroundColor: this.panelColorExists ? this.props.options.panelColor : 'white',
            zIndex: this.showTailExists ? 5 : 1,
        };
    };
    Accordion.prototype.onClick = function (e) {
        var _this = this;
        this.setState({ isOpen: !this.state.isOpen }, function () {
            if (!_this.state.isOpen) {
                if (_this.props.events && _this.props.events.onToggleCollapse) {
                    _this.props.events.onToggleCollapse(e);
                }
            }
            else {
                if (_this.props.events && _this.props.events.onToggleOpen) {
                    _this.props.events.onToggleOpen(e);
                }
            }
        });
    };
    Accordion.prototype.setAccordionState = function (state) {
        this.setState(state);
    };
    Accordion.prototype.render = function () {
        return (React.createElement("div", { className: [styles.accordionContainer, this.getExternalContainerClasses()].join(' ') },
            this.showAccordionPanel(),
            this.showTail(),
            this.showAccordionContent()));
    };
    Accordion.defaultProps = {};
    return Accordion;
}(React.Component));
exports.default = Accordion;
//# sourceMappingURL=Accordion.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Accordion/Accordion.js
// module id = 1339
// module chunks = 8